"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchImportNamesByIds = fetchImportNamesByIds;
exports.fetchImportNameById = fetchImportNameById;

var _immutable = require("immutable");

var _ImmutableAPI = require("../api/ImmutableAPI");

var _ImportNameRecord = _interopRequireDefault(require("./ImportNameRecord"));

var API_BASE = 'inbounddb-io/imports';

var getImportNameRecordFromResp = function getImportNameRecordFromResp(resp, importId) {
  return new _ImportNameRecord.default({
    id: importId,
    importName: resp.hits[importId] || null
  });
};

function fetchImportNamesByIds(importIds) {
  return (0, _ImmutableAPI.put)(API_BASE + "/get-names", importIds, function (resp) {
    return (0, _immutable.Map)(importIds.map(function (id) {
      return [id, getImportNameRecordFromResp(resp, id)];
    }));
  });
}

function fetchImportNameById(importId) {
  return fetchImportNamesByIds((0, _immutable.List)([importId]));
}